import { readSalonSettings } from './salonSettings';

// Каталог салона с учётом правок владельца.
// Демо: услуги/мастера берём из localStorage-настроек (кабинет владельца).
// Прод: эти же данные приходят из D1 через Pages Functions (services, staff).
// Модуль держит единый источник, чтобы витрина, запись и кабинет
// показывали одно и то же после правки.

export type CatalogService = {
  id: string;
  code: string;
  name: string;
  price: number;
  duration_min: number;
  description: string | null;
  popular: boolean;
};

export type CatalogStaff = {
  id: string;
  name: string;
  role: string | null;
  services: string[];
};

// Мастер делает все услуги, если явная связь не задана:
// в кабинете владелец правит мастеров и услуги отдельными списками.
export function catalogFromSettings(): {
  services: CatalogService[];
  staff: CatalogStaff[];
} {
  const s = readSalonSettings();
  const services: CatalogService[] = s.services.map((svc) => ({
    id: svc.id,
    code: svc.id,
    name: svc.name,
    price: svc.price,
    duration_min: svc.durationMinutes,
    description: svc.description ?? null,
    popular: svc.popular ?? false
  }));
  const staff: CatalogStaff[] = s.staff.map((m) => ({
    id: m.id,
    name: m.name,
    role: m.role ?? null,
    services: services.map((svc) => svc.id)
  }));
  return { services, staff };
}
